import axios from "axios";
import { TTP_API_URL } from "../config";
import moment from "moment";

export const getCollaborators = ({ token, organizationId, year }) => {
  const requestUrl = `${TTP_API_URL}/team/budget/collaborators`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      organizationId,
      year,
    },
  });
};

export const getCollaborator = (
  id,
  organizationId,
  token,
  uid = null,
  erpId = null
) => {
  const requestUrl = `${TTP_API_URL}/team/collaborator`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      organization: organizationId,
      uid: uid,
      erpId: erpId,
      id,
    },
  });
};

export const getCollaboratorsTimeSheetNotification = (
  intervals,
  organizationId,
  token
) => {
  const requestUrl = `${TTP_API_URL}/team/collaborator/gd_notifications`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      organizationId: organizationId,
      intervals,
    },
  });
};


export const getTimeSheet = (
  token,
  id,
  partner,
  combination,
  clients,
  clientGroups,
  collaborators,
  types,
  periodUnit,
  periods,
  searchWord,
  clientCRMTypes,
  clientCRMGroup,
  deletedStatus
) => {
  const requestUrl = `${TTP_API_URL}/team/time-sheet`;
  return axios.get(requestUrl, {
    params: {
      access_token: token,
      organizationId: id,
      partner,
      searchWord,
      clients,
      clientGroups,
      collaborators,
      types,
      periodUnit,
      periods: periods,
      cycle: combination,
      clientCRMTypes: clientCRMTypes,
      clientCRMGroup: clientCRMGroup,
      deletedStatus: deletedStatus,

    },

  });
};

export const exportPeriodTimeSheet = async (
  token,
  organizationId,
  combination,
  clients,
  clientGroups,
  collaborators,
  types,
  periodUnit,
  periods,
  searchWord,
  clientCRMTypes,
  clientCRMGroup,
  deletedStatus
) => {
  const requestUrl = `${TTP_API_URL}/team/export/time-sheet`;
  try {
    const params = {
      access_token: token,
      organizationId: organizationId,
      searchWord: searchWord,
      clients: clients,
      clientGroups: clientGroups,
      collaborators: collaborators,
      types: types,
      periodUnit: periodUnit,
      periods: periods,
      cycle: combination,
      clientCRMTypes: clientCRMTypes,
      clientCRMGroup: clientCRMGroup,
      deletedStatus: deletedStatus,
    };

    const response = await axios.get(requestUrl, {
      params,
      responseType: "blob",
      headers: { Accept: "application/vnd.ms-excel" },
    });

    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: response.data.type })
    );
    const link = document.createElement("a");
    link.href = url;

    const date = new Date();
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");
    const dateString = `${day}-${month}-${year} ${hours}-${minutes}-${seconds}`;

    link.setAttribute(
      "download",
      `PowerTeam Financial-sheet ${dateString}.xlsx`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {

    console.error("Error exporting TimeSheet:", error);
    throw new Error("Une erreur est survenue lors de l'exportation.");
  }
};
export const getCollaboratorInProgressEcheance = (
  organizationId,
  collaboratorId,
  year,
  selectedCurentStep,
  selectedClosingDate,
  selectedTvaType,
  selectedBalanceType,
  keyWord,
  token
) => {
  const requestUrl = `${TTP_API_URL}/team/collaborator/in-progress-echeances`;
  const formattedCollaboratorId =
    Array.isArray(collaboratorId) && collaboratorId.length === 1
      ? Number(collaboratorId[0])
      : Array.isArray(collaboratorId) && collaboratorId.length > 1
        ? collaboratorId.map(Number)
        : collaboratorId
          ? Number(collaboratorId)
          : null;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      organizationId: organizationId,
      collaboratorId: formattedCollaboratorId,
      curentStep: selectedCurentStep,
      tvaType: JSON.stringify(selectedTvaType),
      balanceType: selectedBalanceType,
      keyWord: keyWord,
      closingDate: selectedClosingDate,
      year: year,
    },
  });
};
export const getCollaboratorsPlanner = (
  organizationId,
  collaboratorId,
  year,
  token
) => {
  const requestUrl = `${TTP_API_URL}/team/collaborator/planner`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      organizationId: organizationId,
      collaboratorId: collaboratorId,
      year: year,
    },
  });
};

export const saveCollaboratorsPlanner = (
  id,
  organizationId,
  type,
  title,
  meetingPlace,
  collaboratorId,
  collaborators,
  clientId,
  categoryId,
  status,
  date,
  observation,
  color,
  recurrenceDetails,
  selectedBalanceId,
  duration,
  durationTravel,
  parentId,
  year,
  token,
  meetingId,
  meetingUrl,
  additionalEmails,
  isAutoSendClientMeetingLink
) => {
  const requestUrl = `${TTP_API_URL}/team/collaborator/planner-save`;
  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("id", id);
  formData.append("type", type);
  formData.append("title", title);
  if (meetingPlace !== null && meetingPlace !== undefined) {
    formData.append("meetingPlace", meetingPlace);
  }
  formData.append("collaboratorId", collaboratorId);
  formData.append("collaborators", JSON.stringify(collaborators));
  if (clientId !== null && clientId !== undefined) {
    formData.append("clientId", clientId);
  }
  if (categoryId !== null && categoryId !== undefined) {
    formData.append("categoryId", categoryId);
  }
  formData.append("status", status);
  formData.append("date", date);
  if (observation !== null && observation !== undefined) {
    formData.append("observation", observation);
  }
  formData.append("year", year);
  formData.append("balanceId", selectedBalanceId);
  formData.append("duration", duration);
  formData.append("color", color);
  formData.append("recurrenceDetails", JSON.stringify(recurrenceDetails));

  formData.append("durationTravel", durationTravel);
  formData.append("organizationId", organizationId);

  if (parentId) {
    formData.append("parentId", parentId);
  }

  if (meetingId) {
    formData.append("meetingId", meetingId);
  }

  if (meetingUrl) {
    formData.append("meetingUrl", meetingUrl);
  }

  if (additionalEmails && additionalEmails?.length > 0) {
    formData.append("additionalEmails", additionalEmails.join("|"));
  }

  if (
    isAutoSendClientMeetingLink !== null &&
    isAutoSendClientMeetingLink !== undefined
  ) {
    formData.append("autoSendClientMeetingLink", isAutoSendClientMeetingLink);
  }

  return axios.post(requestUrl, formData);
};

export const saveCollaboratorAbsence = (
  token,
  organization,
  planning,
  collaboratorId,
  year,
  month,
  user,
  isUpdating,
  files,
  outlookEventIds
) => {
  const requestUrl = `${TTP_API_URL}/team/collaborator-absence/save`;

  let formData = new FormData();
  formData.append("planning", JSON.stringify(planning));
  formData.append("collaboratorId", collaboratorId);
  formData.append("year", year);
  formData.append("month", month);
  formData.append("user", user);
  formData.append("isUpdating", isUpdating);
  formData.append("access_token", token);
  formData.append("organizationId", organization);
  formData.append("organization_id", organization);

  if (files) {
    files.forEach((element, i) => {
      if (typeof element === "string") {
        return;
      }
      formData.append("files[" + i + "]", element, element.name);
    });
  }

  if (outlookEventIds) {
    formData.append("outlookEvents", JSON.stringify(outlookEventIds));
  }

  return axios.post(requestUrl, formData);
};

export const deleteCollaboratorPlanner = (id, organizationId, token) => {
  const requestUrl = `${TTP_API_URL}/team/collaborator/planner-delete`;

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("id", id);
  formData.append("organizationId", organizationId);

  return axios.post(requestUrl, formData);
};

export const getCollaboratorCalendar = (
  organizationId,
  collaboratorId,
  year,
  token
) => {
  const requestUrl = `${TTP_API_URL}/team/collaborator-absence`;
  let params = {
    access_token: token,
    organizationId: organizationId,
    collaboratorId: collaboratorId,
    year: year,
  };

  return axios.get(requestUrl, {
    params,
  });
};

export const getManagerNotification = (
  uid,
  organizationId,
  token,
  scoop,
  start,
  limit
) => {
  const requestUrl = `${TTP_API_URL}/team/manager_notifications`;
  let parametres = {
    scoop,
    start,
    limit,
  };
  return axios.get(requestUrl, {
    params: {
      access_token: token,
      year: moment().year(),
      uid,
      params: JSON.stringify(parametres),
      organizationId,
    },
  });
};

export const getPersonnalDashboard = (
  organizationId,
  token,
  filter,
  collaboratorId
) => {
  const requestUrl = `${TTP_API_URL}/team/collaborator/personal-dashboard`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      organizationId,
      collaboratorId,
      role: filter.role,
      entityClientId: filter.clients,
      sortBy: filter.sortBy,
      keyWord: filter.keyWord,
      year: filter.year,
      isEntity: filter.isEntity,
      deletedStatus: filter.deletedStatus,
      clientCRMGroup: JSON.stringify(filter.clientCRMGroup),
      clientCRMTypes: JSON.stringify(filter.clientCRMTypes),
    },
  });
};

export const getCollaboratorFinancial = (
  id,
  organization,
  token,
  year,
  filter
) => {
  const requestUrl = `${TTP_API_URL}/team/collaborator/financial`;
  return axios.get(requestUrl, {
    params: {
      organization: organization,
      organization_id: organization,
      access_token: token,
      collaborator: id,
      sortBy: filter.sortBy,
      role: filter.role,
      attribution: filter.attribution,
      clientCRMGroup: JSON.stringify(filter.clientCRMGroup),
      clientCRMTypes: JSON.stringify(filter.clientCRMTypes),
      deletedStatus: filter.deletedStatus,
      year,
      searchWord: filter.keyWord,
    },
  });
};

export const getCollaboratorEmail = ({
  token,
  collaboratorId,
  organizationId,
}) => {
  const requestUrl = `${TTP_API_URL}/team/collaborator/email`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      collaboratorId,
      organization: organizationId,
    },
  });
};

export const saveCollaboratorOutlookHolidaysCalendarId = ({
  token,
  collaboratorId,
  calendarId,
}) => {
  const requestUrl = `${TTP_API_URL}/team/collaborator/outlook/calendars`;

  const formData = new FormData();
  formData.append("access_token", token);
  formData.append("collaboratorId", collaboratorId);
  formData.append("calendarId", calendarId);

  return axios.post(requestUrl, formData);
};

export const saveCollaboratorWorkingDays = ({
  token,
  organizationId,
  collaboratorId,
  year,
  workingDays,
}) => {
  const requestUrl = `${TTP_API_URL}/team/collaborator-absence/save-working-days`;

  const formData = new FormData();
  formData.append("access_token", token);
  formData.append("organizationId", organizationId);
  formData.append("collaboratorId", collaboratorId);
  formData.append("year", year);
  if (workingDays) {
    formData.append("workingDays", JSON.stringify(workingDays));
  }

  return axios.post(requestUrl, formData);
};

export const savePartnerSuspicionRules = ({
  token,
  organizationId,
  partnerId,
  rule,
}) => {
  const requestUrl = `${TTP_API_URL}/team/collaborator/save-suspicion-rules`;

  const formData = new FormData();
  formData.append("access_token", token);
  formData.append("organizationId", organizationId);
  formData.append("partnerId", partnerId);
  formData.append("rule", JSON.stringify(rule));

  return axios.post(requestUrl, formData);
};


export const getPartnerSuspicionRules = ({
  token,
  organizationId,
  partnerId,
}) => {
  const requestUrl = `${TTP_API_URL}/team/collaborator/suspicion-rules`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      partnerId,
      organizationId,
    },
  });
};

export const deleteSuspicionRule = ({
  token,
  organizationId,
  ruleId,
}) => {
  const requestUrl = `${TTP_API_URL}/team/collaborator/delete-suspicion-rule`;

  const formData = new FormData();
  formData.append("access_token", token);
  formData.append("organizationId", organizationId);
  formData.append("ruleId", ruleId);

  return axios.post(requestUrl, formData);
};


export const exportAbsenceMatrix = async (
  token,
  organizationId,
  filter
) => {
  const requestUrl = `${TTP_API_URL}/team/collaborator/export-abscences`;

  try {
    const ids = Array.isArray(filter.collaboratorsErpIds)
      ? filter.collaboratorsErpIds
      : [];

    const params = {
      access_token: token,
      organizationId: organizationId,
      year: filter.year,
      bu: filter.bu ?? null,
      zone: filter.zone ?? null,
      partner: filter.partner ?? null,
      months: JSON.stringify(filter.months ?? []),
      collaborators: ids.join(","),
    };

    const response = await axios.get(requestUrl, {
      params,
      responseType: "blob",
      headers: {
        Accept: "application/vnd.ms-excel",
      },
    });

    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: response.data.type })
    );

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `Absence_Matrix_${filter.year}.xlsx`
    );

    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Error exporting Absence Matrix:", error);
    throw new Error("Une erreur est survenue lors de l'export des absences.");
  }
};
